import { Controller } from "@hotwired/stimulus";

// Formulaire des frais de service GO4SCHOOL : les champs de tarif n'ont de
// sens que lorsque les parents supportent (l'Option 1 est facturée via les
// Abonnements) ; le hint explique le comportement du mode choisi.
export default class extends Controller {
  static targets = ["mode", "pricing", "hint"];
  static values = { hints: Object };

  connect() {
    this.refresh();
  }

  refresh() {
    const mode = this.modeTarget.value;
    const priced = mode !== "establishment_covers";

    this.pricingTargets.forEach((el) => {
      el.classList.toggle("hidden", !priced);
      // Un champ required masqué bloquerait la validation HTML5 ; disabled
      // l'exclut aussi de la soumission (le modèle neutralise les montants)
      el.querySelectorAll("input, select").forEach((field) => {
        field.disabled = !priced;
      });
    });
    if (this.hasHintTarget) {
      this.hintTarget.textContent = this.hintsValue[mode] || "";
    }
  }
}
